// extracted by mini-css-extract-plugin
module.exports = {"contenedorHeader":"layout-module--contenedor-header--32z_G","containerFlotante":"layout-module--container-flotante--2TyAE","whatsappIcon":"layout-module--whatsapp-icon--3kLfC"};